<template>
	<div class="centerPage">
		<div class="bannerEdit">
			<el-form :model="banner" ref="ruleForm">
				<el-upload v-if="banner.bannerType==1"
						name="uploadFile"
						class="avatar-uploader"
                   accept="image/*"
						:action="uploadBannerImgUrl"
						:show-file-list="false"
						:on-success="handleAvatarSuccess">
					<div class="avatar" v-if="imageUrl" :style="'backgroundImage: url('+imageUrl+')'"></div>
					<div v-else class="el-upload__text">点击上传图片<br/>最佳尺寸：1920*950</div>
				</el-upload>
        <el-upload v-if="banner.bannerType==2"
                   name="uploadFile"
                   class="avatar-uploader"
                   accept="image/*"
                   :action="uploadBannerImgUrl"
                   :show-file-list="false"
                   :on-success="handlePosterSuccess">
          <div class="avatar" v-if="posterUrl" :style="'backgroundImage: url('+posterUrl+')'"></div>
          <div v-else class="el-upload__text">点击上传视频封面<br/>最佳尺寸：1920*950</div>
        </el-upload>

        <el-form-item prop="bannerType">
          <el-radio v-model="banner.bannerType" :label="1">图片</el-radio>
          <el-radio v-model="banner.bannerType" :label="2">视频</el-radio>
        </el-form-item>
				<el-form-item prop="imgUrl" v-if="banner.bannerType==1">
					<el-input placeholder="请输入链接地址" v-model="banner.imgUrl"></el-input>
				</el-form-item>
				<el-form-item prop="matchText" v-if="banner.bannerType==1">
					<el-input
							type="textarea"
							:autosize="{ minRows: 3, maxRows: 3}"
							placeholder="请输入简要描述"
							v-model="banner.matchText">
					</el-input>
				</el-form-item>

        <el-upload v-if="banner.bannerType==2"
                   name="uploadFile"
                   accept="video/*"
                   :action="uploadBannerVideoUrl"
                   :show-file-list="true"
                   :limit="1"
                   :before-remove="handleVideoRemove"
                   :on-success="handleVideoSuccess">
          <el-button v-if="!videoUrl" size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传一个video文件，且不超过20M</div>
        </el-upload>

				<el-form-item class="btn">
					<el-button @click="resetForm('ruleForm')">重置</el-button>
					<el-button @click="save()">保存</el-button>
				</el-form-item>
			</el-form>
		</div>


    <!--  已上传banner列表   -->

		<div class="bannerEdit" v-for="(item,index) in bannerList" :key="index">
			<el-form :model="bannerEdit" ref="editForm" v-if="item.bannerType==1">
        <p style="color: #567BFF;margin-bottom: 4px">
          <i class="el-icon-picture-outline"></i>
        </p>
				<el-upload
						v-if="editId == item.id"
						name="uploadFile"
						class="avatar-uploader"
						:action="uploadBannerImgUrl"
						:show-file-list="false"
						:on-success="handleAvatarSuccessEdit">
					<div class="avatar" v-if="imgUrlEdit" :style="'backgroundImage: url('+imgUrlEdit+')'"></div>
					<!--                    <img v-if="item.img" :src="item.img" class="avatar">-->
					<div v-else class="el-upload__text">点击上传<br/>最佳尺寸：1920*950</div>
				</el-upload>
				<div v-else class="avatar-uploader">
					<div class="avatar" v-if="item.imgPath" :style="'backgroundImage: url('+item.imgPath+')'"></div>
				</div>
				<el-form-item style="height: 30px;">
					<el-input placeholder="请输入链接地址" class="inputC" v-if="editId ==item.id"
							  style="border: none; padding: 0"
							  v-model="bannerEdit.imgUrl"></el-input>
					<el-tooltip :content="item.imgUrl" placement="bottom" effect="light" v-else>
						<span class="inputC" style="text-overflow: ellipsis;overflow: hidden;">{{item.imgUrl}}</span>
					</el-tooltip>
					<!--						<span class="inputC" v-else :title="item.imgUrl" style="text-overflow: ellipsis;overflow: hidden;">{{item.imgUrl}}</span>-->
				</el-form-item>
				<el-form-item style="height: 70px" prop="matchText">
					<el-input class="inputText"
							  v-if="editId ==item.id"
							  type="textarea"
							  :autosize="{ minRows: 3, maxRows: 3}"
							  placeholder="请输入简要描述"
							  style="border: none; padding: 0"
							  v-model="bannerEdit.matchText">
					</el-input>
					<span class="inputText" v-else>{{item.matchText}}</span>
				</el-form-item>
				<el-form-item class="btn">
					<el-popconfirm title="确定删除吗？" @confirm="del(item.id)" style="margin-right: 10px">
						<el-button slot="reference" class="delete">删除</el-button>
					</el-popconfirm>

					<el-button v-if="editId ==item.id" @click="saveEdit()">保存</el-button>
					<el-button v-else
							   @click="editId = item.id,bannerEdit.id=item.id,bannerEdit.imgUrl=item.imgUrl,
							   bannerEdit.matchText=item.matchText,bannerEdit.imgPath=item.imgPath,
								imgUrlEdit=item.imgPath">编辑
					</el-button>

				</el-form-item>
			</el-form>

      <el-form v-else class="video-form">
        <p style="color: #567BFF;margin-bottom: 4px">
          <i class="el-icon-film"></i>
        </p>
        <div class="avatar-uploader">
          <video controls :poster="item.videoPoster">
            <source :src="item.videoPath"/>
          </video>
        </div>
        <el-form-item class="btn">
          <el-popconfirm title="确定删除吗？" @confirm="del(item.id)" style="margin-right: 10px">
            <el-button slot="reference" class="delete">删除</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
		</div>
	</div>
</template>

<script>
    import SysCons from '@/api/common';
    import {tooltip} from 'element-ui';

    export default {
        name: "banner",
        data() {
            return {
                uploadBannerImgUrl: SysCons.bannerUploadUrl || '',
                uploadBannerVideoUrl: SysCons.uploadUrl + 'video',

                imageUrl: '',// 新增banner上传组件显示上传的图片
                posterUrl: '', // 新增banner时video poster
                videoUrl: '',// 新增banner上传组件显示上传的video

                imgUrlEdit: '',// 修改banner上传组件显示上传的图片
                banner: {// 新增banner对象
                    bannerType: 1,
                    imgPath: '',
                    imgUrl: '',
                    matchText: '',
                },
                bannerList: [],// 获取的bannerlist
                editId: -999,// 当前编辑状态的bannerID
                bannerEdit: {
                    imgPath: '',
                    imgUrl: '',
                    matchText: ''
                },// 当前编辑的banner对象
            }
        },
        inject: ['reload'],
        mounted() {
            this.getData();
        },
        components: {[tooltip.name]: tooltip},
        methods: {
            save() {// 新增banner
                let vm = this;
                if(vm.banner.bannerType == 1){

                if ($.trim(vm.banner.imgPath) == 0) {
                    vm.$message('请先上传图片');
                    return;
                }
                let params = {
                    imgPath: vm.banner.imgPath,
                    imgUrl: vm.banner.imgUrl,
                    matchText: vm.banner.matchText,
                }
                vm.$ajax.post(SysCons.api.addBanner, params)
                    .then((res) => {
                        if (res.data.status === 'success') {
                            vm.$message({
                                type: "success", message: '操作成功', onClose: () => {
                                    this.reload()
                                }
                            })
                        } else {
                          vm.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  vm.$message.error('操作失败');
                })
                }else if(vm.banner.bannerType == 2){
                  if($.trim(vm.banner.videoPoster).length == 0){
                    vm.$message.warning('视频封面不能为空');return;
                  }
                  if($.trim(vm.banner.videoPath).length == 0){
                    vm.$message.warning('请先上传视频');return;
                  }
                  let params = {
                    videoPoster: vm.banner.videoPoster,
                    videoPath: vm.banner.videoPath,
                  };
                  vm.$ajax.post(SysCons.basePath + 'article/article-banner/authorize/banner-video/add',params).then(res=>{
                    if(res.data.status === 'success'){
                      vm.$message.success('保存成功');
                      vm.reload();
                    }else{
                      vm.$message.error(res.data.message)
                    }
                  });

                }
            },
            saveEdit() {// 保存修改的banner
                let vm = this;
                if ($.trim(vm.bannerEdit.imgPath) == 0) {
                    vm.$message('请先上传图片');
                    return;
                }
                let params = {
                    id: vm.bannerEdit.id,
                    imgPath: vm.bannerEdit.imgPath,
                    imgUrl: vm.bannerEdit.imgUrl,
                    matchText: vm.bannerEdit.matchText,
                }
                vm.$ajax.post(SysCons.api.updateBanner + params.id, params)
                    .then((res) => {
                        if (res.data.status == 'success') {
                            vm.$message({
                                type: "success", message: '操作成功', onClose: () => {
                                    this.reload()
                                }
                            })
                        } else {
                          vm.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  vm.$message.error('操作失败');
                })
            },
            getData() {
                this.$ajax.get(SysCons.api.doctorBanners)
                    .then((res) => {
                        if (res.data.status == 'success' && res.data.list) {
                            this.bannerList = res.data.list
                        }
                    })
            },
            handleAvatarSuccess(res, file) {// 新增上传组件
                this.imageUrl = URL.createObjectURL(file.raw);
                this.banner.imgPath = res.message;
            },
            handleAvatarSuccessEdit(res, file) {// 编辑上传组件
                this.imgUrlEdit = URL.createObjectURL(file.raw);
                this.bannerEdit.imgPath = res.message;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
          handlePosterSuccess(res,file){
              if(res.status == 'success'){
             this.banner.videoPoster = res.message;
                this.posterUrl = res.message;
              }else{
                this.$message.error('上传失败');
              }
          },
          handleVideoSuccess(res,file){
            if(res.status == 'success'){
              this.banner.videoPath = res.message;
              this.videoUrl = res.message;
            }else{
              this.$message.error('上传失败');
            }
          },
          handleVideoRemove(file,fileList){
            this.banner.videoPath = '';
            this.videoUrl = '';
          },
            del(id) {
                let vm = this;
                vm.$ajax.post(SysCons.api.delBanner + id)
                    .then((res) => {
                        if (res.data.status === 'success') {
                            vm.$message({
                                type: 'success', message: res.data.message, onClose: () => {
                                    vm.reload();
                                }
                            })
                        } else {
                          vm.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  vm.$message.error('操作失败');
                });
            },
        }
    }
</script>

<style scoped lang="scss">
@import '../../assets/css/banner.scss';
.video-form{
  video{
    width: 100%;
    height: 100%;
  }
}
</style>
